import { Box, Typography } from '@mui/material';
import { ConfidenceWord, Prose, Section } from './Section';
import { EVIDENCE } from './copy';

const HEADING_ID = 'evidence-title';

export function EvidenceGraded() {
  const last = EVIDENCE.grades.length - 1;
  return (
    <Section labelledBy={HEADING_ID} title={EVIDENCE.title}>
      <Typography sx={{ color: 'var(--ink-muted)', maxWidth: '68ch' }}>
        {EVIDENCE.intro}
      </Typography>

      <Box sx={{ mt: 4, maxWidth: 760 }}>
        {EVIDENCE.grades.map((row, i) => (
          <Box
            key={row.grade}
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '84px 1fr', md: '120px 1fr' },
              columnGap: 2,
              py: 2,
              borderTop: '1px solid var(--rule)',
              borderBottom: i === last ? '1px solid var(--rule)' : 'none',
            }}
          >
            <ConfidenceWord grade={row.grade} sx={{ pt: '3px' }} />
            <Typography variant="body2">{row.body}</Typography>
          </Box>
        ))}
      </Box>

      <Typography sx={{ mt: 4, color: 'var(--ink-muted)', maxWidth: '68ch' }}>
        <Prose parts={EVIDENCE.closing} />
      </Typography>
    </Section>
  );
}
